var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aali_tm_all_wrap",attrs:{"data-magic-cursor":"show"}},[_c('MobileMenu'),_c('Header'),_c('Home'),_c('About'),_c('Skills'),_c('Portfolio'),_c('Service'),_c('Resume'),_c('Counter'),_c('Contact'),_c('Footer'),_c('Mouse')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }